import { render, staticRenderFns } from "./VndTransactionDetailsTable.vue?vue&type=template&id=c0ad2f6c&"
import script from "./VndTransactionDetailsTable.vue?vue&type=script&lang=ts&"
export * from "./VndTransactionDetailsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports